module.exports = __webpack_public_path__ + "img/arrow-right.5fdf9500.png";